<app-dropdown-control
  [data]="options$ | async"
  [disableValueSelector]="disableOnCountZero"
  [displayValueSelector]="displayValueSelector"
  [selectFirstValue]="false"
  [visibleItemsCount]="visibleItemsCount"
  [dataTestId]="'filter-dropdown'"
  [ngModel]="selectedOption$ | async"
  (ngModelChange)="selectOption($event)"
></app-dropdown-control>
